import React from 'react';

const Runs = () => {
  return (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="#6B6C7B"
    >
      <path d="M2.78 2L2 2.41v12l.78.42 9-6V8l-9-6zM3 13.48V3.35l7.6 5.07L3 13.48z" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 14.683l8.78-5.853V8L6 2.147V3.35l7.6 5.07L6 13.48v1.203z"
      />
    </svg>
  );
};

export default Runs;
